import React from 'react';

interface IProps {
  children: any;
  modalOpen: boolean;
  closeModal: () => void;
  title: string;
  closeButtonLabel: string;
}

export const SimpleModal = (props: IProps) => {
  const { children, modalOpen, closeModal, title, closeButtonLabel } = props;

  return (
    <div className={'modal' + (modalOpen ? ' is-active' : '')}>
      <div className="modal-background" onClick={closeModal} />
      <div className="modal-card">
        <header className="modal-card-head">
          <p className="modal-card-title">{title}</p>
          <button className="delete" onClick={closeModal} />
        </header>
        <section className="modal-card-body">
          <div className="content">{children}</div>
        </section>
        <footer className="modal-card-foot">
          <a className="button" onClick={closeModal}>
            {closeButtonLabel}
          </a>
        </footer>
      </div>
    </div>
  );
};
